<template>
  <v-container>
    <h1 class="title text-center">
      Sponsoren
    </h1>
    <v-row
      justify="space-around"
      align="center"
    >
      <v-col
        v-for="sponsor in sponsoren"
        :key="sponsor._id"
        cols="6"
        sm="4"
      >
        <v-card
          elevation="1"
          raised
        >
          <v-card-title class="primary white--text align-end fill-height">
            {{ sponsor.name }}
          </v-card-title>
          <v-card-text>
            <p class="caption">
              Beträge die Du für die einzelnen Wettbewerbe erhälst.
            </p>
            <v-row
              justify="space-around"
            >
              <v-col>
                <b>Spieltag</b><br>
                {{ sponsor.spieltag | currency }}
              </v-col>
              <v-col>
                <b>Meisterschaft</b><br>
                {{ sponsor.meisterschaft | currency }}
              </v-col>
              <v-col>
                <b>Platz 2</b><br>
                {{ sponsor.platz2 | currency }}
              </v-col>

              <v-col>
                <b>Klassenerhalt</b><br>
                {{ sponsor.klassenerhalt | currency }}
              </v-col>

              <v-col>
                <b>Einzel&shy;meisterschaft</b><br>
                {{ sponsor.einzelmeisterschaft | currency }}
              </v-col>

              <v-col>
                <b>Pokal</b><br>
                {{ sponsor.pokal | currency }}
              </v-col>

              <v-col>
                <b>Trainingspunkte</b><br>
                {{ sponsor.tp }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4" />
          <v-card-actions>
            <v-radio-group
              v-model="radioSelected"
              class="mx-auto"
            >
              <v-radio
                :label="sponsor.name + ` auswählen`"
                :value="sponsor.nr"
              />
            </v-radio-group>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// show alle players with name, position, vitalvalues, switch view and so on
export default {
  name: 'SponsorenList',
  props: {
    sponsoren: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      radioSelected: 1
    }
  }
}
</script>
